import LecomRefluxEvents from 'reflux/events/lecom_reflux_events';

export default Object.assign({}, LecomRefluxEvents, {
	// Form events
	DEFINITION_LOAD: "DEFINITION_LOAD",
	DEFINITION_LOAD_SUCCESS: "DEFINITION_LOAD_SUCCESS",
	DEFINITION_LOAD_ERROR: "DEFINITION_LOAD_ERROR",
	INITIAL_VALUES_LOAD: "INITIAL_VALUES_LOAD",
	INITIAL_VALUES_LOAD_SUCCESS: "INITIAL_VALUES_LOAD_SUCCESS",
	INITIAL_VALUES_LOAD_ERROR: "INITIAL_VALUES_LOAD_ERROR",

	// Property setters
	SET_FIELD_PROPERTIES: "SET_FIELD_PROPERTIES",
	SET_ACTION_PROPERTIES: 'SET_ACTION_PROPERTIES',
	SET_FIELD_VALUE: "SET_FIELD_VALUE",

	// Action events
	CLICK: "CLICK",
	EXECUTE_ACTION: "EXECUTE_ACTION",
	EXECUTE_ACTION_SUCCESS: "EXECUTE_ACTION_SUCCESS",
	EXECUTE_ACTION_ERROR: "EXECUTE_ACTION_ERROR",

	// Searcher Action events
	SEARCHER_SELECT: "SEARCHER_SELECT",
	SEARCHER_LOAD: "SEARCHER_LOAD",
	SEARCHER_LOAD_SUCCESS: "SEARCHER_LOAD_SUCCESS",
	SEARCHER_LOAD_ERROR: "SEARCHER_LOAD_ERROR",

	// Submit Action events
	SUBMIT: "SUBMIT",
	SUBMIT_SUCCESS: "SUBMIT_SUCCESS",
	SUBMIT_ERROR: "SUBMIT_ERROR",
	VALIDATION_ERROR: "VALIDATION_ERROR",

	// Save Action events
	SAVE_FORM_SUCCESS: "SAVE_FORM_SUCCESS",
	SAVE_FORM_ERROR: "SAVE_FORM_ERROR",

	// Field events
	FIELD_INITIAL_VALUE_LOAD: "FIELD_INITIAL_VALUE_LOAD",
	FIELD_INITIAL_VALUE_LOAD_SUCCESS: "FIELD_INITIAL_VALUE_LOAD_SUCCESS",
	FIELD_INITIAL_VALUE_LOAD_ERROR: "FIELD_INITIAL_VALUE_LOAD_ERROR",
	FOCUS: "FOCUS",
	BLUR: "BLUR",
	CHANGE: "CHANGE",
	KEY_PRESS: "KEY_PRESS",

	// Autocomplete field events
	AUTOCOMPLETE_DATA_LOAD: "AUTOCOMPLETE_DATA_LOAD",
	AUTOCOMPLETE_DATA_LOAD_SUCCESS: "AUTOCOMPLETE_DATA_LOAD_SUCCESS",
	AUTOCOMPLETE_DATA_LOAD_ERROR: "AUTOCOMPLETE_DATA_LOAD_ERROR",
	CHANGE_OPTIONS: "CHANGE_OPTIONS",
	ADD_OPTIONS: "ADD_OPTIONS",
	REMOVE_OPTIONS: "REMOVE_OPTIONS",
	LOAD_OPTIONS_SUCCESS: "LOAD_OPTIONS_SUCCESS",

	// Grid field events
	GRID_SUBMIT: "GRID_SUBMIT",
	GRID_ADD_SUBMIT: "GRID_ADD_SUBMIT",
	GRID_EDIT_SUBMIT: "GRID_EDIT_SUBMIT",
	GRID_EDIT: "GRID_EDIT",
	GRID_DESTROY: "GRID_DESTROY",
	GRID_RESET: "GRID_RESET",
	GRID_DATA_LOAD_SUCCESS: "GRID_DATA_LOAD_SUCCESS",
	GRID_DATA_LOAD_ERROR: "GRID_DATA_LOAD_ERROR",
	GRID_DATA_ROW_LOADED: "GRID_DATA_ROW_LOADED",	
	GRID_ADD_BEFORE: "GRID_ADD_BEFORE",
	GRID_ADD_AFTER: "GRID_ADD_AFTER",
	GRID_EDIT_BEFORE: "GRID_EDIT_BEFORE",
	GRID_EDIT_AFTER: "GRID_EDIT_AFTER",
	GRID_DELETE_BEFORE: "GRID_DELETE_BEFORE",
	GRID_DELETE_AFTER: "GRID_DELETE_AFTER",

	// Chart field events
	CHART_LOAD: "CHART_LOAD",
	CHART_LOAD_SUCCESS: "CHART_LOAD_SUCCESS",
	CHART_LOAD_ERROR: "CHART_LOAD_ERROR",
	CHART_ITEM_CLICK: "CHART_ITEM_CLICK",
	CHART_UPDATE: "CHART_UPDATE",

	// Document field events
	DOCUMENT_IMPORT_FILE_SUBMITTED: "DOCUMENT_IMPORT_FILE_SUBMITTED",
	UNLINKED_FILE_SUCCESS: "UNLINKED_FILE_SUCCESS",
	DELETE_FILE_SUCCESS: "DELETE_FILE_SUCCESS",
	
	DOCUMENT_IMPORT_SUCCESS: "DOCUMENT_IMPORT_SUCCESS",
	DOCUMENT_IMPORT_ERROR: "DOCUMENT_IMPORT_ERROR",
	DUPLICATED_DOCUMENTS_SUCCESS: "DUPLICATED_DOCUMENTS_SUCCESS",	

	DATE_PICKER_OPEN: "DATE_PICKER_OPEN",
	DATE_PICKER_CLOSE: "DATE_PICKER_CLOSE",

	MUTATION_OBSERVER: "MUTATION_OBSERVER",

	//Loader
	FORM_LOAD_START: "FORM_LOAD_START",
	FORM_LOAD_FINISH: "FORM_LOAD_FINISH",
	FORM_PROCESS_FINISH: "FORM_PROCESS_FINISH",
	READ_ONLY_TOOLBOX_BUTTONS: "READ_ONLY_TOOLBOX_BUTTONS"
});
